var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'el-modal': true,
    [`el-modal--${_vm.size}`]: true,
    'el-modal--borders': _vm.borders,
  },attrs:{"aria-hidden":_vm.ariaHidden,"aria-labelledby":_vm.headerId,"aria-modal":"true","data-qa-es":"modal","role":"dialog","tabindex":"-1"},on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.onDismiss()},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"]))return null;return _vm.onDismiss()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }